export default __webpack_public_path__ + "static/81ba7a188fac94ac76fe5fc00a0820b1.svg";